import { render, staticRenderFns } from "./BaseInputFileListItem.vue?vue&type=template&id=2708fc49&scoped=true&"
import script from "./BaseInputFileListItem.vue?vue&type=script&lang=js&"
export * from "./BaseInputFileListItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFileListItem.vue?vue&type=style&index=0&id=2708fc49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2708fc49",
  null
  
)

export default component.exports